/* BEATSEEK — "Needs ID" pull-out tab (right rail, middle slot) with an unseen counter. */
import React, { useEffect, useState } from 'react';
import { Target } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;
const SEEN_KEY = 'beatseek_needs_id_seen';

export const NeedsIdRail = ({ active, onToggle }) => {
  const [counts, setCounts] = useState({ total: 0, new: 0 });
  const [viewport, setViewport] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);

  const load = () => {
    const since = localStorage.getItem(SEEN_KEY);
    fetch(`${API}/api/wall/needs-id-count${since ? `?since=${encodeURIComponent(since)}` : ''}`)
      .then(r => (r.ok ? r.json() : null))
      .then(d => { if (d) setCounts(d); })
      .catch(() => {});
  };

  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    const onResize = () => setViewport(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  if (viewport < 1100) return null;

  const unseen = counts.new || 0;
  const glow = 'rgba(255,45,120,';

  const handleClick = () => {
    if (!active) {
      localStorage.setItem(SEEN_KEY, new Date().toISOString());
      setCounts(c => ({ ...c, new: 0 }));
    }
    onToggle(!active);
  };

  return (
    <div
      data-testid="needs-id-rail"
      style={{
        position: 'fixed',
        top: 'calc(36vh + 20px)',
        left: 'calc(50% + 356px)',
        display: 'flex',
        alignItems: 'stretch',
      }}
    >
      <button
        data-testid="needs-id-toggle"
        onClick={handleClick}
        title={active ? 'Back to the full Wall' : `${counts.total} clip${counts.total === 1 ? '' : 's'} still need an ID`}
        style={{
          position: 'relative',
          width: '24px',
          background: active
            ? 'linear-gradient(180deg, rgba(255,45,120,0.4), rgba(255,45,120,0.22))'
            : `linear-gradient(180deg, ${glow}0.16), rgba(0,229,255,0.14))`,
          border: `1px solid ${glow}${active ? '0.75' : '0.4'})`,
          borderTopRightRadius: '12px',
          borderBottomRightRadius: '12px',
          borderTopLeftRadius: '12px',
          borderBottomLeftRadius: '12px',
          color: '#ff2d78',
          cursor: 'pointer',
          padding: '14px 0',
          display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px',
          minHeight: '110px',
          boxShadow: active ? `0 8px 22px rgba(0,0,0,0.45), 0 0 16px 4px ${glow}0.5)` : '0 8px 22px rgba(0,0,0,0.45)',
          transition: 'transform 0.2s cubic-bezier(0.22,1,0.36,1), box-shadow 0.2s, border-color 0.2s',
        }}
        onMouseEnter={e => { e.currentTarget.style.transform = 'translateX(4px)'; e.currentTarget.style.boxShadow = `0 12px 28px rgba(0,0,0,0.5), 0 0 20px 5px ${glow}0.65)`; }}
        onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = active ? `0 8px 22px rgba(0,0,0,0.45), 0 0 16px 4px ${glow}0.5)` : '0 8px 22px rgba(0,0,0,0.45)'; }}
      >
        <Target size={13} />
        <div style={{
          writingMode: 'vertical-rl',
          transform: 'rotate(180deg)',
          fontSize: '9px', fontWeight: 800, letterSpacing: '0.18em',
          textTransform: 'uppercase', color: active ? '#fff' : '#ff2d78',
        }}>
          Needs ID
        </div>
        {unseen > 0 && (
          <span
            data-testid="needs-id-unseen-count"
            style={{
              position: 'absolute', top: '-6px', right: '-7px',
              minWidth: '17px', height: '17px', padding: '0 4px', borderRadius: 999,
              background: '#ff2d78', color: '#fff', fontSize: '9px', fontWeight: 800,
              display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
              boxShadow: '0 0 10px rgba(255,45,120,0.8)',
            }}
          >
            {unseen > 9 ? '9+' : unseen}
          </span>
        )}
      </button>
    </div>
  );
};

export default NeedsIdRail;
